module.exports = __webpack_public_path__ + "static/media/danger-icon.4e5d48c4.svg";